<template>
  <div class="fragment">
    <div class="input-col">
      <slot></slot>
      <div class="form-field form-textbox form-group">
        <SeverityDropdown
          :propID="propSeverityName ? this.propSeverityName : `${this.propName}SeverityID`"
          :formData="formData"
          :tabindex="tabindex"
          :mappings="mappings"
        />
      </div>
    </div>
  </div>
</template>

<script>
import StringHelper from 'services/string-helper.service';
import SeverityDropdown from '../../shared/SeverityDropdown.vue';

export default {
  name: 'SampleDetailParticleAutoCompleteControl',
  computed: {
    severityProp() {
      return this.propSeverityName ? this.propSeverityName : `${this.propName}SeverityID`;
    }
  },
  components: {
    SeverityDropdown
  },
  props: {
    tabindex: {
      type: Number,
      default() {
        return 0;
      }
    },
    propName: {
      type: String
    },
    propSeverityName: {
      type: String
    },
    formData: {
      type: Object
    },
    mappings: {
      type: Object,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
:deep(.autocomplete) {
  .flex-autocomplete-field {
    flex-grow: 0 !important;

    .autocomplete-text {
      padding-right: 0;
    }
  }

  &.form-group {
    margin-right: -3px !important;
  }

  .k-textbox-label {
    min-width: 120px !important;
    width: 120px !important;
  }
}

.input-col {
  display: flex;
  flex: 1;
  flex-basis: 15%;
}
</style>
